/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export type VoucherStatus = typeof VoucherStatus[keyof typeof VoucherStatus];


export const VoucherStatus = {
  DRAFT: 'DRAFT',
  PUBLISHED: 'PUBLISHED',
  ARCHIVED: 'ARCHIVED',
} as const;
